
import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper, ButtonSizeOptions } from "@loanbossinc/component-library";
import shortid from "shortid";
import { remove } from "lodash";

import { hasBrokerAccess } from "../deal-settings-rows-logic";

export const rows = {
  title: {
    label: "Deal Organization",
    isTitle: true
  },
  titleGroups: {
    label: "Groups",
    isTitle: true
  },
  groups: {
    hasNestedRows: true,
    key: "funds",
    label: "Group",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              label: "Group",
              key: `fundDealBridge-${index}`,
              name: `funds[${index}].id`,
              componentorder: 0,
              collectionname: "companyFunds",
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id
            })
          },

          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove",
              size: ButtonSizeOptions.sm,
              name: `funds[${index}].fundDealBridge.id`,
              onClick: (value, formik) => {
                if (value) {
                  const values = formik.values;
                  values.funds = remove(values.funds, item => item.fundDealBridge.id !== value);
                  formik.handleChange();
                  formik.handleBlur();
                }
              },
              style: { width: "132px", marginTop: "10px", float: "right" }
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.PERCENT,
              label: "Allocation %",
              name: `funds[${index}].fundDealBridge.allocationPercent`,
              variant: "filled",
              decimals: "3",
              style: { marginTop: "10px", marginLeft: "0" }
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.SWITCH,
              label: "Primary",
              name: `funds[${index}].fundDealBridge.isPrimary`
            })
          }
        ]
      }
    ]
  },
  addGroupRecord: {
    key: "addGroupRecord",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON,
        label: "Add New",
        hideLabel: true,
        size: ButtonSizeOptions.sm,
        onClick: (value, formik) => {
          const values = formik.values;
          const newItem = {
            id: null,
            name: null,
            fundDealBridge: {
              id: `NEW-${shortid.generate()}`,
              dealId: null,
              companyId: null,
              allocationPercent: null,
              isPrimary: false
            }
          };
          values.funds.push(newItem);
          formik.handleChange();
          formik.handleBlur();
        },
        style: { width: "132px", marginTop: "10px", float: "right" }
      }
    ]
  },

  titleCollaborationGroup: {
    label: "Add a Collaborator",
    isTitle: true
  },
  collaborationGroup: {
    hasNestedRows: true,
    key: "collaborationGroups",
    label: "Collaborator",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              label: "Group",
              key: `collaborationGroups-${index}`,
              name: `collaborationGroups[${index}].id`,
              componentorder: 0,
              collectionname: "collaborationGroup",
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id
            })
          },

          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove",
              size: ButtonSizeOptions.sm,
              name: `collaborationGroups[${index}].fundDealBridge.id`,
              onClick: (value, formik) => {
                if (value) {
                  const values = formik.values;
                  values.collaborationGroups = remove(values.collaborationGroups, item => item.fundDealBridge.id !== value);
                  formik.handleChange();
                  formik.handleBlur();
                }
              },
              style: { width: "132px", marginTop: "10px", float: "right" }
            })
          }

        ]
      }
    ]
  },
  addCollaborationGroupRecord: {
    key: "addCollaborationGroupRecord",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON,
        label: "Add New",
        hideLabel: true,
        size: ButtonSizeOptions.sm,
        onClick: (value, formik) => {
          const values = formik.values;
          const newItem = {
            id: null,
            name: null,
            fundDealBridge: {
              id: `NEW-${shortid.generate()}`,
              dealId: null,
              companyId: null,
              allocationPercent: null,
              isPrimary: false
            }
          };
          values.collaborationGroups.push(newItem);
          formik.handleChange();
          formik.handleBlur();
        },
        style: { width: "132px", marginTop: "10px", float: "right" }
      }
    ]
  },

  sponsorCompanyId:
  {
    label: "Sponsor Company",
    isVisible: data => hasBrokerAccess(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "sponsorCompany",
        name: "sponsorCompanyId",
        variant: "filled",
        parentId: "sponsorCompanies",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  }
};

